/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = (props) => makeStyles((theme) => ({
    headerContainer: {
        // display: 'flex',
        // flexDirection: 'column',
        // alignItems: 'center',
        // gap: '0.5rem',
        marginTop: '4rem',
        marginBottom: `${props.page === 'GetStarted' ? '0' : '3rem'}`
    },
    header: {
        display: 'flex !important',
        flexDirection: 'column',
        gap: '0.5rem',
        alignItems: 'center',
    },
    line1: {
        display: 'inline-block',
        fontFamily: 'Roboto Condensed, serif',
        fontSize: '1.125rem !important',
        color: '#B3261D !important',
        lineHeight: '16px',
        letterSpacing: '1px',
        fontWeight: '700 !important',
        margin: '0 !important',
    },
    line2: {
        display: 'inline-block',
        fontFamily: 'Playfair Display',
        fontWeight: 600,
        color: '#B3261D !important',
        fontSize: '5rem !important',
        margin: '4px 0 0 0 !important',
        lineHeight: '4.5rem',
        [theme.breakpoints.down('sm')]: {
            fontSize: '3.5rem !important',
            lineHeight: '3.5rem !important',
        },
    },
    line3: {
        display: 'inline-block',
        fontSize: '4rem !important',
        fontFamily: 'Roboto Condensed',
        fontWeight: 400,
    }
}));

const PlayBookHeader = (props) => {
    const classes = useStyles(props)();
    return (
        <div className={classes.headerContainer}>
            <h1 className={classes.header}>
                <span className={classes.line1}>
                    THE OFFICIAL 1-800-FLOWERS
                </span>
                <span className={classes.line2}>
                    VALENTINE'S
                </span>
                <span className={classes.line3}>
                    PLAYBOOK
                </span>
            </h1>
        </div>
    )
};

export default PlayBookHeader;